module.exports = __webpack_public_path__ + "img/map.deba451b.png";